import {Component, effect, inject, Injector, runInInjectionContext, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {DatePipe, NgClass} from '@angular/common';
import {toSignal} from '@angular/core/rxjs-interop';
import {catchError, of} from 'rxjs';
import {NotificationService} from '../../notification/notification.service';
import {CustomerService} from '../../services/customer.service';
import {LoyaltyTransactionTypeLabelEnum} from '../../enum/loyalty-transaction-type-label.enum';
import {Router} from '@angular/router';

@Component({
  selector: 'app-loyalty-point',
  imports: [MatDialogModule, MatIcon, MatExpansionModule, MatPaginator, DatePipe, NgClass],
  templateUrl: './loyalty-point.component.html',
  styleUrl: './loyalty-point.component.scss',
  standalone: true
})
export class LoyaltyPointComponent {
  private customerService = inject(CustomerService);
  private notificationService = inject(NotificationService);
  private injector = inject(Injector);
  dialogRef = inject(MatDialogRef<LoyaltyPointComponent>);
  private router = inject(Router);
  public data = inject(MAT_DIALOG_DATA, {optional: true});
  loyaltyHistory: any[] = [];
  pageIndex = 0;
  pageSize = 10;
  totalElements = 0;
  readonly isLoading = signal<boolean>(false);
  isEmpty = false;

  ngOnInit() {
    this.loadHistory();
  }

  get loyaltyPoints(): number {
    return this.data?.points ?? 0;
  }

  loadHistory() {
    this.isLoading.set(true);
    runInInjectionContext(this.injector, () => {
      const historySignal = toSignal(
        this.customerService.getLoyaltyPoints(this.pageIndex, this.pageSize).pipe(
          catchError(err => {
            this.notificationService.errorHandler(err);
            this.isLoading.set(false);
            return of(null);
          })
        ),
        {initialValue: null}
      );

      effect(() => {
        const result = historySignal();
        if (!result) return;

        const body: any = result.body;
        this.loyaltyHistory = (body?.data?.content ?? [])
          .map((item: any) => ({
            ...item,
            typeLabel: LoyaltyTransactionTypeLabelEnum[item.type as keyof typeof LoyaltyTransactionTypeLabelEnum]
          }))
          .filter((item: any) => item.points !== 0);
        console.log('points', this.loyaltyHistory)

        this.totalElements = body?.data?.totalElements ?? 0;
        this.isEmpty = this.loyaltyHistory.length === 0;
        this.isLoading.set(false);
      });
    });
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadHistory();
  }

  redeemPoints(): void {
    this.close();
    // Redirection vers la page produit en mode conversion de points
    this.router.navigate(['/product'], {
      queryParams: {mode: 'redeem'},
      queryParamsHandling: 'merge'
    });
  }

  close() {
    this.dialogRef.close();
  }
}
